import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const PerformanceSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9961 1.8999C8.04985 1.8999 4.81274 5.14476 4.81274 9.11065C4.81274 10.0345 4.99109 10.9216 5.31445 11.7373C5.71717 12.7533 6.34481 13.6586 7.13298 14.3862L7.14084 21.2994C7.14086 21.5581 7.20876 21.7605 7.33697 21.899C7.46597 22.0384 7.6439 22.0999 7.83635 22.0999C8.17366 22.0999 8.42496 21.8903 8.64639 21.6768L8.64756 21.6756L11.6358 18.6989C11.8214 18.5213 11.9279 18.478 12.0076 18.478C12.0868 18.478 12.1896 18.5206 12.3758 18.6989L12.3766 18.6996L15.3605 21.6756L15.3616 21.6767C15.6003 21.9074 15.8509 22.0999 16.1797 22.0999C16.3771 22.0999 16.5564 22.0389 16.6853 21.8988C16.8132 21.7599 16.8787 21.5572 16.8787 21.2993V14.3587C18.2883 13.0546 19.1794 11.1733 19.1874 9.11085C19.1955 5.14444 15.9385 1.8999 11.9961 1.8999ZM6.30702 9.11065C6.30702 5.92107 8.81251 3.36242 12.0041 3.36242C15.1918 3.36242 17.6933 5.92094 17.7011 9.11089C17.7089 12.3001 15.1922 14.8623 12.0043 14.8545C8.81224 14.8467 6.30702 12.2999 6.30702 9.11065Z"
        fill={color}
      />
    </svg>
  );
};

export { PerformanceSvg };
